import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css';
import coursesData from "../../data/CourseData";
import '../../styles/EbookDetail.css'
import ebookData from "../../data/EbookData";
import { getLocation } from "../utils/GetLocation";
import { trackMetaEvent } from '../utils/MetaPixel';
import InscriptionModalEbook from "../modals/InscriptionModalEbook";
import InscriptionModal from "../modals/InscriptionModal";
import UpsellModal from '../modals/UpsellModal'; // 2. Importa el nuevo modal que crearemos

// --- Icon Components (Replacing Lucide script for better React integration) ---
const Icon = ({ name, className }) => {
    const icons = {
        infinity: <><path d="M3.5 9.5c5.1 2.9 8.4 2.9 13.5 0" /><path d="M20.5 9.5c-5.1 2.9-8.4 2.9-13.5 0" /><path d="M12 12s4.5 4.5 0 9s-4.5-9 0-9" /><path d="M12 12s-4.5 4.5 0 9s4.5-9 0-9" /></>,
        puzzle: <><path d="M19.43 12.03a2.5 2.5 0 1 1 0-4.06l-1.72-.43A2.5 2.5 0 0 1 19.43 12.03z" /><path d="M12.03 4.57a2.5 2.5 0 1 1 4.06 0l.43 1.72a2.5 2.5 0 0 1-4.06 0l.43-1.72z" /><path d="M4.57 12.03a2.5 2.5 0 1 1 0 4.06l1.72.43a2.5 2.5 0 0 1 0-4.06l-1.72-.43z" /><path d="M12.03 19.43a2.5 2.5 0 1 1-4.06 0l-.43-1.72a2.5 2.5 0 0 1 4.06 0l-.43 1.72z" /><path d="M17.5 7.5a2.5 2.5 0 0 1-2.5 2.5H10v1.5h1.5a2.5 2.5 0 0 1 2.5 2.5v4.5" /><path d="M6.5 17.5a2.5 2.5 0 0 1 2.5-2.5H14v-1.5h-1.5a2.5 2.5 0 0 1-2.5-2.5V6.5" /></>,
        frown: <><circle cx="12" cy="12" r="10" /><path d="M16 16s-1.5-2-4-2-4 2-4 2" /><path d="M9 9h.01" /><path d="M15 9h.01" /></>,
        'check-circle-2': <><path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" /><path d="m9 12 2 2 4-4" /></>,
        'brain-circuit': <><path d="M12 2a10 10 0 0 0-4.3 19.22" /><path d="M18 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z" /><path d="M12 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z" /><path d="M4.5 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" /><path d="M19.2 7.5c.2-.2.4-.4.6-.6" /><path d="M14 12.5a4.1 4.1 0 0 0 6.8-2.3" /><path d="M11.2 13.5c-1.8.5-3.2 2-4.2 3.5" /><path d="M6.5 7.7c.6-.2 1.3-.3 2-.3" /><path d="M20 13.5c0 .2 0 .4 0 .6" /><path d="M12 22c-1.8 0-3.5-.4-5-1.2" /><path d="m4.5 10.5 1 1" /><path d="m14 14 1 1" /></>,
        box: <><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" /><path d="m3.3 7 8.7 5 8.7-5" /><path d="M12 22V12" /></>,
        'git-compare': <><circle cx="18" cy="18" r="3" /><circle cx="6" cy="6" r="3" /><path d="M13 6h3a2 2 0 0 1 2 2v7" /><path d="M11 18H8a2 2 0 0 1-2-2V9" /></>,
        repeat: <><path d="M17 2.1l4 4-4 4" /><path d="M3 12.6V8a4 4 0 0 1 4-4h14" /><path d="M7 21.9l-4-4 4-4" /><path d="M21 11.4V16a4 4 0 0 1-4 4H3" /></>,
        blender: <><path d="M12 12H7a5 5 0 1 1 5-5V2a10 10 0 1 0 10 10h-5" /><path d="M12 12v5a5 5 0 0 0 5 5" /><path d="M12 2v5a5 5 0 0 1-5 5" /></>,
        map: <><polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21" /><line x1="9" x2="9" y1="3" y2="18" /><line x1="15" x2="15" y1="6" y2="21" /></>,
        'shield-check': <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><path d="m9 12 2 2 4-4" /></>,
        'chevron-down': <path d="m6 9 6 6 6-6" />,
    };
    return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>{icons[name]}</svg>;
};


const FAQItem = ({ id, question, answer, openFaq, setOpenFaq }) => {
    const isOpen = openFaq === id;

    return (
        <div className="card px-6 py-4">
            <button onClick={() => setOpenFaq(isOpen ? 0 : id)} className="w-full text-left flex justify-between items-center text-lg font-semibold">
                <span>{question}</span>
                <Icon name="chevron-down" className={`w-6 h-6 transform transition-transform ${isOpen ? 'rotate-180' : ''}`} />
            </button>
            <div className={`faq-content ${isOpen ? 'open' : ''}`}>
                <p className="mt-4 text-gray-400">{answer}</p>
            </div>
        </div>
    );
};


// --- Main EbookDetail Component ---

export default function EbookDetail() {

    const { id } = useParams();

    // --- Estados ---
    const [showModal, setShowModal] = useState(false); // Modal original del ebook
    const [showModalCourse, setShowModalCourse] = useState(false); // Modal del curso
    const [showUpsellModal, setShowUpsellModal] = useState(false); // 4. Nuevo estado para el modal de la oferta
    const [price, setPrice] = useState({ oldPrice: "No Disponible", newPrice: "No Disponible", priceInscription: "No Disponible" });
    const [openFaq, setOpenFaq] = useState(0);
    const [country, setCountry] = useState('');

    // --- Handlers para el modal original ---
    const handleShowModal = () => setShowModal(true);
    const handleShowModalCourse = () => setShowModalCourse(true);
    const handleCloseModal = () => setShowModal(false);
    const handleCloseModalCourse = () => setShowModalCourse(false);

    // --- Handlers para el NUEVO modal de oferta ---
    const handleShowUpsellModal = () => setShowUpsellModal(true);
    const handleCloseUpsellModal = () => setShowUpsellModal(false);

    let countryValues = 'us';

    // 5. Lógica para cuando el usuario ACEPTA la oferta del curso
    const handleUpsellConfirm = () => {
        setShowUpsellModal(false); // Cierra el modal de oferta
        handleShowModalCourse(); // Abre el modal para comprar el curso
    };

    // 6. Lógica para cuando el usuario RECHAZA la oferta y quiere solo el ebook
    const handleUpsellDecline = () => {
        setShowUpsellModal(false); // Cierra el modal de oferta
        handleShowModal(); // Abre el modal original para comprar el ebook

        // Movemos el tracking del pixel aquí, porque ahora es cuando realmente inicia el checkout del ebook
        trackMetaEvent('InitiateCheckout', {
            content_name: ebook.title,
            content_ids: [ebook.id],
            currency: price.currency,
            value: price.newPrice
        });
    };

    //Mover el scroll al inicio cuando se carga la página
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Buscar el curso por ID en la lista de cursos
    const ebook = ebookData.find(ebook => ebook.id === id);
    // Buscar el curso por ID en la lista de cursos
    const course = coursesData.find(course => course.id === ebook.idCourse);

    useEffect(() => {
        getLocation().then(({ countryCode }) => {
            const resolvedCountry = countryCode || 'us';
            setCountry(resolvedCountry);

            const countryValues = ebook.values[resolvedCountry] || ebook.values["us"];
            const countryValuesCourse = course.values[resolvedCountry] || course.values["us"];
            setPrice({
                newPrice: countryValues.newPrice.toLocaleString("de-DE"),
                oldPrice: countryValues.oldPrice.toLocaleString("de-DE"),
                newPriceCourse: countryValuesCourse.newPrice.toLocaleString("de-DE"),
                currency: countryValues.currency,
                priceFormat: countryValues.newPrice,
                priceFormatCourse: countryValuesCourse.newPrice
            });
        });
    }, [ebook.values]);

    useEffect(() => {
        if (ebook) {
            // 🔹 Enviar evento de "ViewContent" cuando alguien entra a la página del curso
            trackMetaEvent('ViewContent', {
                content_name: ebook.title,
                content_category: 'Ebook',
                content_ids: [ebook.id]
            });
        }
    }, [ebook]);

    // Initialize AOS (Animate on Scroll)
    useEffect(() => {
        AOS.init({
            duration: 700,
            once: true,
        });
    }, []);

    return (
        <>
            <div id="import-course-lp" className="antialiased">
                {/* HEADERS */}
                <header className="relative overflow-hidden py-20 md:py-32">
                    <div className="absolute inset-0 bg-grid-gray-700/10 [mask-image:linear-gradient(to_bottom,white_5%,transparent_90%)]"></div>
                    <div className="container mx-auto px-6 text-center relative z-10">
                        <h1 className="text-4xl md:text-6xl font-extrabold text-white" data-aos="fade-up">
                            {ebook.titleMain.map((fragment, idx) => (
                                <span key={idx} style={fragment.style}>
                                    {fragment.text}{' '}
                                </span>
                            ))}
                        </h1>
                        <p className="mt-6 text-lg md:text-xl max-w-3xl mx-auto text-gray-400" data-aos="fade-up" data-aos-delay="200">
                            {ebook.hook.map((fragment, idx) => (
                                <span key={idx} style={fragment.style}>
                                    {fragment.text}{' '}
                                </span>
                            ))}
                        </p>
                        <div className="mt-10" data-aos="fade-up" data-aos-delay="400">
                            <a href="#comprar" className="cta-button inline-block bg-cyan-400 text-slate-900 font-bold text-lg px-10 py-4 rounded-lg">
                                {ebook.mainButtonText}
                            </a>
                            <p className="mt-4 text-sm text-gray-500">{ebook.subButtonText}</p>
                        </div>
                    </div>
                    <div class="attractive-top-bar">
                        <div class="attractive-top-bar">
                            <div class="top-bar-content">
                                <p class="top-bar-text">
                                    <strong>{ebook.hookMain}</strong>
                                </p>
                            </div>
                        </div>
                    </div>
                </header>
                <main>
                    {/* PROBLEMS */}
                    <section className="py-20">
                        <div className="container mx-auto px-6">
                            <h2 className="text-3xl font-bold text-center text-white" data-aos="fade-up">{ebook.problems.title}</h2>
                            <p className="text-center mt-2 text-gray-400 max-w-2xl mx-auto" data-aos="fade-up" data-aos-delay="100">{ebook.problems.subtitle}</p>
                            <div className="grid md:grid-cols-3 gap-8 mt-12 text-center">
                                <div className="card p-6" data-aos="zoom-in" data-aos-delay="200">
                                    <Icon name={ebook.problems.items[0].icon} className="w-12 h-12 text-cyan-400 mx-auto mb-4" />
                                    <h3 className="font-bold text-xl text-white">{ebook.problems.items[0].title}</h3>
                                    <p className="mt-2 text-gray-400">{ebook.problems.items[0].description}</p>
                                </div>
                                <div className="card p-6" data-aos="zoom-in" data-aos-delay="300">
                                    <Icon name={ebook.problems.items[1].icon} className="w-12 h-12 text-cyan-400 mx-auto mb-4" />
                                    <h3 className="font-bold text-xl text-white">{ebook.problems.items[1].title}</h3>
                                    <p className="mt-2 text-gray-400">{ebook.problems.items[1].description}</p>
                                </div>
                                <div className="card p-6" data-aos="zoom-in" data-aos-delay="400">
                                    <Icon name={ebook.problems.items[2].icon} className="w-12 h-12 text-cyan-400 mx-auto mb-4" />
                                    <h3 className="font-bold text-xl text-white">{ebook.problems.items[2].title}</h3>
                                    <p className="mt-2 text-gray-400">{ebook.problems.items[2].description}</p>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* SOLUTION */}
                    <section className="py-20 bg-[#161B22] overflow-hidden">
                        <div className="container mx-auto px-6">
                            <div className="flex flex-col md:flex-row items-center gap-12 md:gap-20">
                                <div className="md:w-1/2 lg:w-2/5" data-aos="fade-right">
                                    <img src={ebook.coverImage}
                                        alt="Portada del Ebook Programación para Todos;"
                                        className="ebook-cover w-full max-w-sm mx-auto"
                                        loading="lazy" />
                                </div>
                                <div className="md:w-1/2 lg:w-3/5" data-aos="fade-left" data-aos-delay="200">
                                    <h2 className="text-3xl md:text-4xl font-bold text-white">{ebook.solution.title.map((fragment, idx) => (
                                        <span key={idx} style={{ ...fragment.style }}>
                                            {fragment.text}
                                        </span>
                                    ))}
                                    </h2>
                                    <p className="mt-4 text-lg text-gray-300">
                                        {ebook.solution.description.map((fragment, idx) => (
                                            <span key={idx} style={{ ...fragment.style }}>
                                                {fragment.text}
                                            </span>
                                        ))}
                                    </p>
                                    <ul className="mt-6 space-y-4">
                                        {ebook.solution.points.map((line, i) => (
                                            <li key={i} className="flex items-start">
                                                <Icon name="check-circle-2" className="w-6 h-6 text-green-400 mr-3 mt-1 flex-shrink-0" />
                                                <span>
                                                    {line.map((part, j) => (
                                                        <span key={j} style={part.style}>{part.text}</span>
                                                    ))}
                                                </span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* FEATURES */}
                    <section className="py-20">
                        <div className="container mx-auto px-6">
                            <h2 className="text-3xl font-bold text-center text-white" data-aos="fade-up">
                                {ebook.features.title}
                            </h2>
                            <div className="max-w-4xl mx-auto mt-12 grid md:grid-cols-2 gap-6">
                                {ebook.features.items.map((f, i) => (
                                    <div key={i} className="card p-6 flex flex-col items-center text-center space-y-4" data-aos="fade-up" data-aos-delay={f.delay}>
                                        <Icon name={f.icon} className="w-10 h-10 text-cyan-400" />
                                        <h3 className="font-semibold text-white text-lg">{f.title}</h3>
                                        <p className="text-gray-400">{f.description}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>

                    {/* CTA */}
                    <section id="comprar" className="py-20 bg-[#161B22]">
                        <div className="container mx-auto px-6">
                            <div className="card max-w-2xl mx-auto p-8 md:p-12 text-center border-2 border-cyan-400/50" data-aos="zoom-in-up">
                                <h2 className="text-3xl font-extrabold text-white">{ebook.cta.title}</h2>
                                <p className="mt-4 text-lg text-gray-300">{ebook.cta.subtitle}</p>
                                <div className="my-8">
                                    <p className="text-3xl text-slate-500 line-through" style={{ color: 'red' }}>Antes: {price.oldPrice} {price.currency}</p>
                                    <p className="text-6xl md:text-7xl font-bold text-white"><span className="text-3xl text-gray-400">Ahora:</span> {price.newPrice} <span className="text-3xl text-gray-400">{price.currency}</span></p>
                                    <p className="text-gray-400 mt-2">Un único pago, tienes tu libro digital para siempre.</p>
                                </div>
                                <button
                                    className="cta-button animated-glow w-full inline-block bg-cyan-400 text-slate-900 font-bold text-xl px-12 py-5 rounded-lg"
                                    onClick={handleShowUpsellModal}
                                >
                                    {ebook.cta.buttonText}
                                </button>
                                <div className="mt-8 flex items-center justify-center p-4 rounded-lg bg-green-500/10 text-green-300">
                                    <Icon name="shield-check" className="w-8 h-8 mr-3 flex-shrink-0" />
                                    <div>
                                        <h4 className="font-bold text-white">{ebook.cta.guarantee.title}</h4>
                                        <p className="text-sm text-green-400">{ebook.cta.guarantee.description}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* FAQS */}
                    <section className="py-20">
                        <div className="container mx-auto px-6 max-w-3xl">
                            <h2 className="text-3xl font-bold text-center text-white mb-12" data-aos="fade-up">{ebook.faq.title}</h2>
                            <div className="space-y-4" data-aos="fade-up" data-aos-delay="200">
                                {ebook.faq.items.map(faq => (
                                    <FAQItem key={faq.id} {...faq} openFaq={openFaq} setOpenFaq={setOpenFaq} />
                                ))}
                            </div>
                        </div>
                    </section>
                </main>
            </div>
            {/* Modal de Inscripción curso */}
            <InscriptionModal show={showModalCourse} handleClose={handleCloseModalCourse} course={course} newPrice={price.priceFormatCourse} currency={price.currency} country={country} />
            {/* Modal de compra Ebook */}
            <InscriptionModalEbook show={showModal} handleClose={handleCloseModal} ebook={ebook} newPrice={price.priceFormat} currency={price.currency} country={country} />
            {/* Nuevo Modal de Oferta (Upsell) */}
            <UpsellModal
                show={showUpsellModal}
                course={course} newPrice={price.priceFormat} currency={price.currency} country={country}
                handleClose={handleCloseUpsellModal}
                onConfirm={handleUpsellConfirm}
                onDecline={handleUpsellDecline}
            />
        </>
    );
}
